define.alias("shared/components/shared/social/refresh-profile", "settings/components/shared/social/refresh-profile");